<app-template-notification [value]="value" [control]="control" [severity]="severity" [links]="links" [sslinks]="sslinks" />
